import type { FormField, FormValues } from "@prequel/import-react";
import { DEFAULT_FORM_ROOT_KEY, getFormValue } from "@prequel/import-react";
import { DetailList, DetailRow } from "@prequel/shared-components";

import { formatFieldValue } from "./formFieldValues";

const EmptyValue = () => <span className="text-stone-400">&mdash;</span>;

const HiddenValue = () => <span className="text-stone-400 italic">Intentionally hidden</span>;

type FormFieldDetailsProps = {
  fields: FormField[];
  values: FormValues;
  rootKey?: string;
};

const FormFieldDetails = ({ fields, values, rootKey = DEFAULT_FORM_ROOT_KEY }: FormFieldDetailsProps) => (
  <DetailList>
    {fields
      .filter((field) => !!field.label)
      .map((field) => {
        if (field.write_only) {
          return <DetailRow key={field.path} label={field.label} value={<HiddenValue />} />;
        }

        const formatted = formatFieldValue(field, getFormValue(values, field.path, rootKey));
        return <DetailRow key={field.path} label={field.label} value={formatted ?? <EmptyValue />} />;
      })}
  </DetailList>
);

export default FormFieldDetails;
